import request from '@/utils/server'
export function getMaintenance(data) {
    return request({
      url: '/device/maintenance',
      method: 'POST',
     data:data
    })
  }